import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as filtersApi from '../../../api/filters';
import { history } from '../../../store/history';
import { routes } from '../../../constants/RouterPath';
import { Thunk } from '../../../helpers/redux/Thunk';
import { FilterItem } from '../../../types/Endpoints/filters/FiltersContracts';
import { addNotification } from '../../notifications/addNotification';
import { TypesSnackbars } from '../../../types/TypesSnackbars';
import { TypesIcon } from '../../../types/TypesIcon';

export const EDIT_FILTER = 'catalog/editFilter';

const onSuccess = (): Thunk => async dispatch => {
    history.push(routes.filters);

    dispatch(addNotification({
        type: TypesSnackbars.SUCCESS,
        message: {
            title: 'Изменения сохранены',
            description: '',
        },
        icon: TypesIcon.SNACK_SUCCES,
    }));
};

export const editFilter = createAsyncThunk(
    EDIT_FILTER,
    createRequest({
        type: EDIT_FILTER,
        loader: async ({ requestData, filterId }: {requestData: Partial<FilterItem>, filterId: string}) => filtersApi.editFilter(requestData, filterId),
        onSuccess,
    }),
);
